// removed by extract-text-webpack-plugin
module.exports = {"icon":"AddFilterBox__icon___2umRJ","addText":"AddFilterBox__addText___3MQ_1","addFilterContainer":"AddFilterBox__addFilterContainer___1cKvv","addIcon":"AddFilterBox__addIcon___35hn6"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/project/potentialMatches/components/AddFilterBox.scss
// module id = 1627
// module chunks = 0